import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../../../App/Components'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'

import { GraphContainer } from './style'

interface IProps {
  userUuid: string
}

export const ProfileDoughnutChart = ({ userUuid }: IProps) => {
  const { t } = useTranslation()

  const { absenceRequests, personStatistics } = useAppSelector(state => {
    return {
      absenceRequests: state.hr.absenceRequests.list,
      personStatistics: state.hr.absenceRequests.statistics,
    }
  })

  if (
    typeof absenceRequests === 'undefined' ||
    typeof personStatistics === 'undefined'
  ) {
    return <Spinner />
  }

  const personStats = personStatistics.find(
    person => person.personUuid === userUuid,
  )

  if (!personStats) {
    return null
  }

  const taken: number = Math.round((personStats.taken / 60) * 100) / 100
  const planned: number = Math.round((personStats.planned / 60) * 100) / 100
  const pending: number = Math.round((personStats.pending / 60) * 100) / 100
  const balance: number = Math.round((personStats.balance / 60) * 100) / 100
  const remaining: number = balance - taken - planned - pending

  const labels: string[] = []
  const colors: string[] = ['#005cdb', '#2377F0', '#73ADFF', '#DCE7F1']
  const innerData = []

  if (taken > 0) {
    innerData.push(taken)
    labels.push(t('Taken'))
    colors.push('#005cdb')
  }
  if (planned > 0) {
    innerData.push(planned)
    labels.push(t('Planned'))
    colors.push('#2377F0')
  }
  if (pending > 0) {
    innerData.push(pending)
    labels.push(t('Pending'))
    colors.push('#73ADFF')
  }

  if (remaining > 0) {
    innerData.push(remaining)
    labels.push(t('Remaining hours'))
    colors.push('#DCE7F1')
  }

  if (taken + planned + pending === 0) {
    return null
  }

  const data = {
    responsive: true,
    maintainAspectRatio: false,
    labels,
    datasets: [
      {
        label: t('My Absences'),
        data: innerData,
        backgroundColor: colors,
        hoverOffset: 4,
        borderRadius: 20,
      },
    ],
  }

  return (
    <GraphContainer>
      <Doughnut data={data} redraw width={200} height={200} />
    </GraphContainer>
  )
}
